export default from './LoadingBar'


// WEBPACK FOOTER //
// ./src/components/Modules/LoadingBar/index.js